// @ts-nocheck

export const localeCodes =  [
  "en",
  "ja"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_040fb81c",
      load: () => import("#nuxt-i18n/040fb81c" /* webpackChunkName: "locale_en_46json_040fb81c" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_98ba325a",
      load: () => import("#nuxt-i18n/98ba325a" /* webpackChunkName: "locale_ja_46json_98ba325a" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    iso: "en",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ja",
    iso: "ja",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

